import React from 'react';
import { buildPrepTime }  from '../globals';
import '../css/common.css';
import '../css/main.css';
import '../css/recipe_list_item.css';

const RecipeListItem = ({recipe, onRecipeSelect, evenrow}) => {
  var imageUrl;

  if (recipe === undefined)
  return "";

  if (recipe.Type !== "CATEGORY") {
    if (recipe.ImageUrls.length > 0)
    {
      imageUrl = recipe.ImageUrls[0];
    }
    else {
      imageUrl = "";
    }
  }
  return (
    recipe.Type === "CATEGORY" ?
      <li className="ultra-light-bk list-group-category main-font">{recipe.Name}</li>
    :
      <li id="bob" onClick={() => onRecipeSelect(recipe)} className={evenrow === true ? 'list-group-item main-font' : 'list-group-item main-font list-even'}>
        <div className="recipe-item-group">
          <div className="list-group-item-img-div">
            <img alt="" className="list-group-item-img" src={imageUrl} />
          </div>
          <div className="recipe-item-group-data">
            <div className="list-group-item-name">
              {recipe.Name}
            </div>
            <div className="list-group-sub-title">
              <span className="bold blue-font">Servings:&nbsp;</span>{recipe.Servings}<span className="bold blue-font">&nbsp;&nbsp;&nbsp;Cook Time&nbsp;</span>{buildPrepTime(recipe.Cook_Minutes)}
            </div>
          </div>
        </div>
      </li>
  );
};

export default RecipeListItem;



// WEBPACK FOOTER //
// ./src/components/recipe_list_item.js